export default __webpack_public_path__ + "static/media/ave-ai.7987b5f7.ico";